var firebaseConfig = {
  apiKey: "AIzaSyB0VrVxFnB2iYW-SgLS0Zbgfaq7kOVDeYA",
  authDomain: "mychurchdemo-c4153.firebaseapp.com",
  databaseURL: "https://mychurchdemo-c4153.firebaseio.com",
  projectId: "mychurchdemo-c4153",
  storageBucket: "gs://mychurchdemo-c4153.appspot.com",
  messagingSenderId: "536994826005",
  appId: "1:536994826005:web:9114560543b7cb2d"
}; 
exports.config = firebaseConfig;


// WEBPACK FOOTER //
// ./src/config/firebase_config.js